import { render, staticRenderFns } from "./PasswordDarwer.vue?vue&type=template&id=4bf7909c&scoped=true"
import script from "./PasswordDarwer.vue?vue&type=script&lang=js"
export * from "./PasswordDarwer.vue?vue&type=script&lang=js"
import style0 from "./PasswordDarwer.vue?vue&type=style&index=0&id=4bf7909c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7909c",
  null
  
)

export default component.exports